import { TFunction } from "next-i18next";
import { withCdnUrl } from "@smile2impress/attraction-utils";

import { mergeContent } from "utils/mergeContent";
import contacts from "configs/contacts";
import { PageContentProps } from "content/content.types";
import {
    OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE,
    UrlsConfig,
} from "configs/urlsConfig";

import defaultContent from "./common";

const pageContent = (t: TFunction, { locale }: PageContentProps) => {
    const content = defaultContent(t, { locale });

    return mergeContent(content, {
        header: {
            menuTitle: t("navigationMenuRelaunch:navigationMenu"),
            logoLink: UrlsConfig.MAIN,
            items: [
                {
                    text: t("navigationMenuRelaunch:navigationTreatments"),
                    highlighted: true,
                    items: [
                        {
                            text: t(
                                "navigationMenuRelaunch:navigationAligners"
                            ),
                            link: UrlsConfig.ALIGNERS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/aligners.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/aligners.png"
                                ),
                            },
                        },
                        {
                            text: t(
                                "navigationMenuRelaunch:navigationRetainers"
                            ),
                            link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/retainers.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/retainers.png"
                                ),
                            },
                        },
                        {
                            text: t("navigationMenuRelaunch:navigationTeens"),
                            link: UrlsConfig.TEENS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/teens.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/teens.png"
                                ),
                            },
                        },
                    ],
                },
                {
                    text: t("navigationMenuRelaunch:navigationWhitening"),
                    link: UrlsConfig.WHITENING,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/whitening.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/whitening.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationWhy"),
                    link: UrlsConfig.WHY_IMPRESS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/whyImpress.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/whyImpress.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationPricing"),
                    link: UrlsConfig.PRICES,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/prices.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/prices.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationClinics"),
                    link: UrlsConfig.LOCATIONS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/aligners/steps-to-treatment-3.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/aligners/steps-to-treatment-3.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationResults"),
                    link: UrlsConfig.RESULTS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/results.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/results.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationBlog"),
                    link: UrlsConfig.BLOG,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/blog.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/blog.png"
                        ),
                    },
                },
            ],
        },
        footer: {
            company: {
                links: [
                    {
                        id: "whyImpress",
                        name: t("global:whyImpressPageTitle"),
                        link: UrlsConfig.WHY_IMPRESS,
                    },
                    {
                        id: "press",
                        name: t("global:pressPageTitle"),
                        link: `mailto:${contacts.emailPress.link}`,
                    },
                    {
                        id: "careers",
                        name: t("global:careersPageTitle"),
                        link: "https://www.linkedin.com/company/impress-orthodontics/jobs/",
                        target: "_blank",
                    },
                    {
                        id: "offersAndDiscounts",
                        name: t("navigationMenuRelaunch:offersAndDiscounts"),
                        link: OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale],
                    },
                ],
            },
            product: {
                links: [
                    {
                        id: "aligners",
                        name: t("global:alignersPageTitle"),
                        link: UrlsConfig.ALIGNERS,
                    },
                    {
                        id: "teens",
                        name: t("global:teensPageTitle"),
                        link: UrlsConfig.TEENS,
                    },
                    {
                        id: "retainers",
                        name: t("global:nightRetainersPageTitle"),
                        link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                    },
                    {
                        id: "malocclusion",
                        name: t("navigationMenuRelaunch:malocclusion"),
                        link: UrlsConfig.MALOCCLUSION,
                    },
                    {
                        id: "crossbite",
                        name: t("navigationMenuRelaunch:clusterBCrossbite"),
                        link: UrlsConfig.CROSSBITE,
                    },
                    {
                        id: "crooked_teeth",
                        name: t("navigationMenuRelaunch:clusterBCrookedTeeth"),
                        link: UrlsConfig.CROOKED_TEETH,
                    },
                    {
                        id: "diastema",
                        name: t("navigationMenuRelaunch:clusterBDiastema"),
                        link: UrlsConfig.DIASTEMA,
                    },
                ],
            },
        },
        contacts: {
            wa: null,
            tg: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.telegram[locale].link,
            },
        },
    });
};

export default pageContent;
